interface ResultFieldProps {
  color?: string;
  label: string;
  value: React.ReactNode;
}

// Generic label-over-value tile shared by SummaryCard and ImpactCard so both surfaces render
// results with identical typography instead of duplicating the same markup.
export const ResultField: React.FC<ResultFieldProps> = ({ color, label, value }) => (
  <div className="slds-p-vertical_xx-small">
    <p className="slds-text-title_caps slds-text-color_weak">{label}</p>
    <p className="slds-text-body_regular slds-text-heading_small" style={color ? { color } : undefined}>
      {value}
    </p>
  </div>
);
